/** Increment when changing encodes; old immutable outputs remain valid. */
export const MEDIA_RECIPE_VERSION = "v1";
export const MEDIA_IMAGE_WIDTHS = [320, 640, 1080, 1600] as const;
export const MEDIA_MAX_SOURCE_BYTES = 512 * 1024 * 1024;
export const MEDIA_MAX_VIDEO_SECONDS = 10 * 60;
export const HLS_SEGMENT_SECONDS = 3;

export function outputFrameRate(sourceFps: number): number {
  return Math.min(30, Math.max(1, Number.isFinite(sourceFps) ? sourceFps : 30));
}

export function videoRenditions(width: number, height: number) {
  const shortEdge = Math.min(width, height);
  const targets = [360, 540, 720].filter((size) => size <= shortEdge);
  if (!targets.length) targets.push(shortEdge);
  return targets.map((size) => {
    const scale = Math.min(size / shortEdge, 1920 / Math.max(width, height), 1);
    return {
      width: Math.max(2, Math.floor((width * scale) / 2) * 2),
      height: Math.max(2, Math.floor((height * scale) / 2) * 2),
      bitrate: size <= 360 ? 600_000 : size <= 540 ? 1_200_000 : 2_400_000,
    };
  });
}
